import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "apt-market-summary" }
const _hoisted_2 = { class: "kpi-grid" }
const _hoisted_3 = { class: "kpi-card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "최근 12개월 거래량", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "kpi-sk kpi-sk-val" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "kpi-sk kpi-sk-delta" }, null, -1)
const _hoisted_7 = { class: "kpi-value" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "건", -1)
const _hoisted_9 = { class: "kpi-card" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "최근 12개월 평균가", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "kpi-sk kpi-sk-val" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "kpi-sk kpi-sk-delta" }, null, -1)
const _hoisted_13 = { class: "kpi-value" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "억", -1)
const _hoisted_15 = { class: "kpi-card" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "kpi-label" }, "최근 1년 최고 평균가", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "kpi-sk kpi-sk-val" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "kpi-sk kpi-sk-delta" }, null, -1)
const _hoisted_19 = { class: "kpi-value" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "억", -1)
const _hoisted_21 = {
  key: 0,
  class: "kpi-delta neutral"
}
const _hoisted_22 = { class: "kpi-note" }
const _hoisted_23 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_5,
              _hoisted_6
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_7, [
                _createTextVNode(_toDisplayString(_ctx.recentCount.toLocaleString()), 1),
                _hoisted_8
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["kpi-delta", _ctx.deltaClass(_ctx.countYoy)])
              }, "전년 동기 대비 " + _toDisplayString(_ctx.deltaText(_ctx.countYoy)), 3)
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_11,
              _hoisted_12
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_13, [
                _createTextVNode(_toDisplayString(_ctx.recentAvg.toFixed(1)), 1),
                _hoisted_14
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["kpi-delta", _ctx.deltaClass(_ctx.avgYoy)])
              }, "전년 동기 대비 " + _toDisplayString(_ctx.deltaText(_ctx.avgYoy)), 3)
            ], 64))
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_17,
              _hoisted_18
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_19, [
                _createTextVNode(_toDisplayString(_ctx.peakAmount.toFixed(1)), 1),
                _hoisted_20
              ]),
              (_ctx.peakLabel)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.peakLabel) + " 기준", 1))
                : _createCommentVNode("", true)
            ], 64))
      ])
    ]),
    _createElementVNode("p", _hoisted_22, [
      _createTextVNode(" 국토교통부 신고 특성상 최근 1~2개월 거래는 확정 전이라 수치가 늘어날 수 있습니다. "),
      (_ctx.dataAsOf)
        ? (_openBlock(), _createElementBlock("span", _hoisted_23, "· 데이터 기준 " + _toDisplayString(_ctx.dataAsOf), 1))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.loading && _ctx.avgYoy !== null)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/apt/stats",
          class: "kpi-analyze"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" 평균가 " + _toDisplayString(_ctx.avgYoy > 0 ? '상승' : '하락') + "(" + _toDisplayString(_ctx.deltaText(_ctx.avgYoy)) + ")이 실제 시세 변동인지, 거래 구성(평형) 변화인지 분석하기 → ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}